// ============================================================================
// CLIENT-SIDE SECTOR RANK
//
// Mirrors server/services/sectorClassifier.js (SECTOR_ETFS + classifySectorRanks)
// for the client. Used by the TradingPage SignalHealth widget so the on-screen
// HOLD/MONITOR/EXIT verdict factors in sector rotation the same way the
// background 15-min health monitor does.
// ============================================================================

export const SECTOR_ETF_MAP = {
  tech:           'XLK',
  finance:        'XLF',
  healthcare:     'XLV',
  energy:         'XLE',
  consumer:       'XLY',
  industrials:    'XLI',
  materials:      'XLB',
  utilities:      'XLU',
  communications: 'XLC',
  realestate:     'XLRE',
};

// Build a sector → rank Map ('leading' | 'neutral' | 'lagging') from a quote
// map keyed by ETF ticker. Returns an empty Map when fewer than 5 sector ETF
// quotes are usable — sector RS is too noisy below that.
export function classifyClientSectorRanks(quoteByEtf) {
  if (!quoteByEtf) return new Map();
  const ranked = [];
  for (const [sector, etf] of Object.entries(SECTOR_ETF_MAP)) {
    const q = quoteByEtf[etf];
    const change = q?.changePct;
    if (change == null || !Number.isFinite(change)) continue;
    ranked.push({ sector, change: Number(change) });
  }
  if (ranked.length < 5) return new Map();

  ranked.sort((a, b) => b.change - a.change);
  const top    = Math.max(1, Math.ceil(ranked.length * 0.2));
  const bottom = Math.max(1, Math.ceil(ranked.length * 0.2));
  const out = new Map();
  for (let i = 0; i < ranked.length; i++) {
    if (i < top)                          out.set(ranked[i].sector, 'leading');
    else if (i >= ranked.length - bottom) out.set(ranked[i].sector, 'lagging');
    else                                  out.set(ranked[i].sector, 'neutral');
  }
  return out;
}
